export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12889.7d34adf1.jpg";